import React from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Avatar from "./Avatar"
import Cell from "./Cell"
import RowTotal from "./RowTotal"
import { EMPTY } from "../hooks/useCellIndex"
import { dayTone } from "../lib/days"
import { sumHours } from "../lib/hours"

const selectedKeyOf = (items, selection) => {
  if (selection.size === 0) return ""
  return items.filter(item => selection.has(item.id)).map(item => item.id).join(",")
}

const PersonRow = ({ user, days, template, cells, absences, selection, range, weeks, subtitle }) => {
  const rowKey = user ? user.id : "none"
  let total = 0
  const rendered = days.map(day => {
    const items = cells.get(`${rowKey}|${day.date}`) || EMPTY
    total += sumHours(items)
    const inRange = Boolean(range && range.rowKey === rowKey && day.date >= range.from && day.date <= range.to)
    return (
      <Cell
        key={day.date}
        userId={user ? user.id : null}
        date={day.date}
        tone={dayTone(day)}
        items={items}
        absence={user ? absences.get(`${user.id}|${day.date}`) : undefined}
        selectedKey={selectedKeyOf(items, selection)}
        inRange={inRange}
      />
    )
  })

  return (
    <div className="grid group/row" style={{ gridTemplateColumns: template }}>
      <div className={clsx(
        "sticky left-0 z-[5] flex items-center gap-2.5 px-3 py-2 border-r border-b border-slate-200 min-w-0",
        user ? "bg-white group-hover/row:bg-slate-50" : "bg-amber-50/70",
      )}>
        {user ? <Avatar user={user} size="md" /> : (
          <span className="grid place-items-center w-8 h-8 rounded-full bg-amber-100 text-amber-600 shrink-0">
            <FontAwesomeIcon icon="inbox" className="text-[12px]" />
          </span>
        )}
        <div className="min-w-0">
          <div className="text-[13px] font-semibold text-slate-800 truncate">{user ? user.name : I18n.t("project_planning.unknown_person")}</div>
          <div className="text-[11px] text-slate-400 truncate">{subtitle}</div>
        </div>
      </div>
      {rendered}
      {user
        ? <RowTotal total={total} base={(user.weekly_hours || 0) * weeks} />
        : <RowTotal total={total} base={0} />}
    </div>
  )
}

export default PersonRow
